var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "common" }, [
    _c("div", { staticClass: "page-btns-main" }, [
      _c(
        "div",
        { staticClass: "page-main no-shadow" },
        [
          _c(
            "a-steps",
            { staticClass: "common-step", attrs: { current: _vm.current } },
            _vm._l(_vm.steps, function(item) {
              return _c("a-step", {
                key: item.title,
                attrs: { title: item.title }
              })
            }),
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        [
          _c(
            "keep-alive",
            [
              _c(_vm.steps[_vm.current].comp, {
                ref: "bankComp",
                tag: "component",
                attrs: {
                  params: _vm.steps[_vm.current].params,
                  text: _vm.steps[_vm.current].text,
                  readonly: true,
                  bankCd: _vm.bankCd
                },
                on: {
                  "update:bankCd": function($event) {
                    _vm.bankCd = $event
                  },
                  "update:bank-cd": function($event) {
                    _vm.bankCd = $event
                  }
                }
              })
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "spaceCenter page-bottom-btns" },
      [
        _vm.current == 0
          ? _c(
              "a-button",
              {
                staticClass: "btn-big",
                attrs: { type: "primary" },
                on: { click: _vm.next }
              },
              [_vm._v("\n      下一步\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.current == 1
          ? _c(
              "a-button",
              {
                staticClass: "btn-big",
                staticStyle: { "margin-left": "8px" },
                attrs: { type: "primary" },
                on: { click: _vm.prev }
              },
              [_vm._v("\n      上一步\n    ")]
            )
          : _vm._e(),
        _vm._v(" "),
        _c("a-button", { staticClass: "btn-big", on: { click: _vm.goback } }, [
          _vm._v("\n      返回\n    ")
        ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c95899e0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c95899e0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/bank/bank-info.vue
// module id = CwOT
// module chunks = 1